import ComingSoonPage from "../components/shared/ComingSoonPage";

export default function TableGrazing() {
  return (
    <ComingSoonPage
      pageId="table-grazing"
      pageTestId="table-grazing-page"
      titleLine1="Table Grazing"
      titleLine2="in Hyderabad"
      description={<>Beautifully styled <b>grazing tables</b> packed with cheeses, fresh fruits, chocolates, mithai, charcuterie and seasonal florals — designed for your next celebration in Hyderabad.</>}
      subCopy="We're still curating the perfect spreads. Drop your email and we'll let you know the moment we launch."
      launchDateISO="2026-10-01T00:00:00+05:30"
      accentColor="#E08036"
    />
  );
}
